<template>
    <div class="chart-container">
      <b-card class="sales-chart">
        <b-card-header>
          <b-card-title>
            Quantity and Value of Products Sold Over Time
          </b-card-title>
        </b-card-header>
  
   
        <apexcharts
          type="line"
          height="350"
          :options="chartOptions"
          :series="filteredSeries"
        ></apexcharts>
      </b-card>
    </div>
  </template>
  
  <script>
  import VueApexCharts from "vue-apexcharts";
  import {
    BCard,
    BCardTitle,
    BCardHeader,
    BRow,
    BCol,
    BFormInput,
  } from "bootstrap-vue";
  
  export default {
    name: "ProductsSoldComboChart",
    components: {
      apexcharts: VueApexCharts,
      BCard,
      BCardTitle,
      BCardHeader,
      BRow,
      BCol,
      BFormInput,
    },
    data() {
      return {
       
        salesData: [
          { date: "2024-01-01", quantity: 120, value: 1000 },
          { date: "2024-01-02", quantity: 150, value: 1300 },
          { date: "2024-01-03", quantity: 180, value: 1600 },
          { date: "2024-01-04", quantity: 90,  value: 700 },
          { date: "2024-01-05", quantity: 130, value: 1100 },
          { date: "2024-01-06", quantity: 170, value: 1400 },
          { date: "2024-01-07", quantity: 140, value: 1200 },
          { date: "2024-01-08", quantity: 200, value: 1800 },
          { date: "2024-01-09", quantity: 80,  value: 600 },
          { date: "2024-01-10", quantity: 160, value: 1500 },
        ],
   
        startDate: "2024-01-01",
        endDate: "2024-01-10",
      };
    },
    props: {
      data: {
        type: Array,
        required: true,
        default: () => [],
      },
    },
    computed: {

     
      filteredCategories() {
        return this.data.map((item) => item.period);
      },
    
      filteredSeries() {
        return [
          {
            name: "Quantity",
            type: "line",
            data: this.data.map((item) => item.totalQuantitySold),
          },
          {
            name: "Value",
            type: "column",
            data: this.filteredData.map((item) => item.totalValueSold),
          },
        ];
      },

      chartOptions() {
        return {
          chart: {
            id: "combo-chart",
          },
          xaxis: {
            categories: this.filteredCategories,
            title: { text: "Time" },
          },
          yaxis: [
            {
              title: {
                text: "Quantity of Products Sold",
              },
            },
            {
              opposite: true,
              title: {
                text: "Value of Products Sold",
              },
            },
          ],
          stroke: {
            curve: "smooth",
          },
          tooltip: {
            shared: true,
          },
          legend: {
            position: "top",
          },
        };
      },
    },
    methods: {

      updateChart() {
      
      },
    },
  };
  </script>
